import { Injectable } from '@angular/core';
import { TutorialModel } from 'src/app/core/model/object/tutorial-model';

@Injectable({
  providedIn: 'root',
})
export class TutorialDataService {
  constructor() {}

  public getTutorial(): Promise<TutorialModel> {
    const tutorialJson = localStorage.getItem('tutorial');
    const tutorial = TutorialModel.fromJSON(tutorialJson);
    if (tutorial) {
      return Promise.resolve(tutorial);
    }
  }

  public saveTutorial(tutorial: TutorialModel) {
    localStorage.setItem('tutorial', JSON.stringify(tutorial));
  }

  public removeTutorial() {
    localStorage.setItem('tutorial', '');
  }
}
